import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { IconRegularTouch } from '@notino/react-styleguide';

import messages from '../../../messages';

import { ModiFaceWrapper, TextWrapper } from './styled';

interface IModiFaceOverlayProps {
  onClick: (e: React.MouseEvent) => void;
}

export const ModiFaceOverlay: React.FC<IModiFaceOverlayProps> = ({
  onClick,
}) => {
  return (
    <ModiFaceWrapper onClick={onClick}>
      <IconRegularTouch color="icon.inverse" width="32px" height="37px" />
      <TextWrapper>
        <FormattedMessage {...messages.tryItOnYourself} />
      </TextWrapper>
    </ModiFaceWrapper>
  );
};
